import React from 'react'
import ManageOrgPlanMapping from '../../../components/OrgPlanMapping'

const OrgPlanMappingPage = () => {
    return (
        <div class="w-full">
            <ManageOrgPlanMapping />
        </div>
    )
}

export default OrgPlanMappingPage
